function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useRef, useState } from "react";
import Flicking from "@egjs/react-flicking";
import { twMerge } from "@stereoagency/tailwind-config";
import { DotPagination, SectionHeader, SmallLinkImageCard } from "../../molecules";
import { Container, EntryAnimation } from "../../atoms";
export default function SmallLinkImageCardsSection(param) {
    var title = param.title, subtitle = param.subtitle, cards = param.cards, className = param.className;
    var containerRef = useRef(null);
    var flickingRef = useRef(null);
    var _useState = _sliced_to_array(useState(0), 2), currentIndex = _useState[0], setCurrentIndex = _useState[1];
    var handleWillChange = function(event) {
        setCurrentIndex(event.index);
    };
    var handleSelect = function(index) {
        if (flickingRef.current) {
            var _flickingRef_current;
            if (flickingRef.current.animating) {
                flickingRef.current.stopAnimation();
            }
            (_flickingRef_current = flickingRef.current) === null || _flickingRef_current === void 0 ? void 0 : _flickingRef_current.moveTo(index);
        }
    };
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        name: SmallLinkImageCardsSection.name,
        background: "subtle",
        className: twMerge("overflow-hidden", className)
    }, /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef,
        className: "mb-6 md:mb-10"
    }, /*#__PURE__*/ React.createElement(SectionHeader, {
        title: title,
        subtitle: subtitle,
        className: "text-left md:text-center"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "hidden w-full mx-auto max-w-md md:block"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "md:grid md:grid-flow-row md:auto-rows-max md:gap-3"
    }, cards.map(function(card, cardIndex) {
        var _card_action;
        return /*#__PURE__*/ React.createElement(EntryAnimation, {
            key: "card-".concat(card.title, "-").concat((_card_action = card.action) === null || _card_action === void 0 ? void 0 : _card_action.href),
            view: containerRef,
            delay: cardIndex / 10
        }, /*#__PURE__*/ React.createElement(SmallLinkImageCard, card));
    }))), /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef,
        className: "block md:hidden"
    }, /*#__PURE__*/ React.createElement(Flicking, {
        ref: flickingRef,
        align: "prev",
        moveType: "strict",
        onWillChange: handleWillChange
    }, cards.map(function(card) {
        var _card_action;
        return /*#__PURE__*/ React.createElement("div", {
            key: "card-".concat(card.title, "-").concat((_card_action = card.action) === null || _card_action === void 0 ? void 0 : _card_action.href),
            className: "w-full mr-3"
        }, /*#__PURE__*/ React.createElement(SmallLinkImageCard, card));
    })), /*#__PURE__*/ React.createElement(DotPagination, {
        active: currentIndex,
        count: cards.length,
        className: "mt-5 mb-1",
        onSelect: handleSelect
    })));
}

//# sourceMappingURL=SmallLinkImageCardsSection.js.map